import { render, staticRenderFns } from "./LoggedUserPreview.vue?vue&type=template&id=b79b3f9e&"
import script from "./LoggedUserPreview.vue?vue&type=script&lang=js&"
export * from "./LoggedUserPreview.vue?vue&type=script&lang=js&"
import style0 from "./LoggedUserPreview.vue?vue&type=style&index=0&id=b79b3f9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports